"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsUniqueLang = void 0;
const class_validator_1 = require("class-validator");
const I18nTextResource_1 = require("../I18nText/I18nTextResource");
const array_1 = require("../../utils/array");
function IsUniqueLang(validationOptions = {}) {
    return function (object, propertyName) {
        (0, class_validator_1.registerDecorator)({
            name: "isUniqueLang",
            target: object.constructor,
            propertyName: propertyName,
            options: validationOptions,
            validator: {
                validate(value) {
                    if (!Array.isArray(value))
                        return false;
                    if (!value.every((item) => item instanceof I18nTextResource_1.I18nTextResource))
                        return false;
                    return (0, array_1.isUnique)(value.map((item) => item.lang));
                },
                defaultMessage(args) {
                    return `${args.property} should be an array with no duplicate lang values`;
                },
            },
        });
    };
}
exports.IsUniqueLang = IsUniqueLang;
